import { inject, InjectionToken } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export const WINDOW = new InjectionToken<Window>('Browser window object', {
	providedIn: 'root',
	factory: () => inject(DOCUMENT).defaultView,
});
